var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:bank"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.14648 11.1748V10.2654L15.334 2.76538L27.5215 10.2654V11.1748H3.14648Z",
    fill: "url(#paint0_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.14648 11.1748V10.2654L15.334 2.76538L27.5215 10.2654V11.1748H3.14648Z",
    fill: "url(#paint1_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.14648 11.1748V10.2654L15.334 2.76538L27.5215 10.2654V11.1748H3.14648Z",
    fill: "url(#paint2_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.14648 11.1748V10.2654L15.334 2.76538L27.5215 10.2654V11.1748H3.14648Z",
    fill: "url(#paint3_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.14648 11.1748V10.2654L15.334 2.76538L27.5215 10.2654V11.1748H3.14648Z",
    fill: "url(#paint4_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_i_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.92383 9.44971L14.0395 3.13096C14.827 2.63408 15.8395 2.63408 16.627 3.13096L26.7426 9.44971V11.2216L15.9613 4.52783C15.577 4.29346 15.0988 4.29346 14.7145 4.52783L3.9332 11.2216V9.44971H3.92383Z",
    fill: "url(#paint5_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M3.92383 9.44971L14.0395 3.13096C14.827 2.63408 15.8395 2.63408 16.627 3.13096L26.7426 9.44971V11.2216L15.9613 4.52783C15.577 4.29346 15.0988 4.29346 14.7145 4.52783L3.9332 11.2216V9.44971H3.92383Z",
    fill: "url(#paint6_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M3.92383 9.44971L14.0395 3.13096C14.827 2.63408 15.8395 2.63408 16.627 3.13096L26.7426 9.44971V11.2216L15.9613 4.52783C15.577 4.29346 15.0988 4.29346 14.7145 4.52783L3.9332 11.2216V9.44971H3.92383Z",
    fill: "url(#paint7_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.92383 9.44971L14.0395 3.13096C14.827 2.63408 15.8395 2.63408 16.627 3.13096L26.7426 9.44971V11.2216L15.9613 4.52783C15.577 4.29346 15.0988 4.29346 14.7145 4.52783L3.9332 11.2216V9.44971H3.92383Z",
    fill: "url(#paint8_radial_434_3160)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_f_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M4.88672 9.59415L10.9711 5.89478",
    stroke: "url(#paint9_linear_434_3160)",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_f_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.9863 3.28369L25.1138 8.93682",
    stroke: "url(#paint10_linear_434_3160)",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M24.709 10.2842H5.95898V26.2217H24.709V10.2842Z",
    fill: "#96919E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.709 10.2842H5.95898V26.2217H24.709V10.2842Z",
    fill: "url(#paint11_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M24.709 10.2842H5.95898V26.2217H24.709V10.2842Z",
    fill: "url(#paint12_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M24.709 10.2842H5.95898V26.2217H24.709V10.2842Z",
    fill: "url(#paint13_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M26.584 13.719H23.7715V26.1999H26.584V13.719Z",
    fill: "url(#paint14_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M26.584 13.719H23.7715V26.1999H26.584V13.719Z",
    fill: "url(#paint15_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M26.584 13.719H23.7715V26.1999H26.584V13.719Z",
    fill: "url(#paint16_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M26.584 13.719H23.7715V26.1999H26.584V13.719Z",
    fill: "url(#paint17_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M22.834 13.7407H20.0215V26.2217H22.834V13.7407Z",
    fill: "url(#paint18_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M22.834 13.7407H20.0215V26.2217H22.834V13.7407Z",
    fill: "url(#paint19_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M22.834 13.7407H20.0215V26.2217H22.834V13.7407Z",
    fill: "url(#paint20_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M22.834 13.7407H20.0215V26.2217H22.834V13.7407Z",
    fill: "url(#paint21_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M10.6465 13.7407H7.83398V26.0088H10.6465V13.7407Z",
    fill: "url(#paint22_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M10.6465 13.7407H7.83398V26.0088H10.6465V13.7407Z",
    fill: "url(#paint23_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M10.6465 13.7407H7.83398V26.0088H10.6465V13.7407Z",
    fill: "url(#paint24_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M10.6465 13.7407H7.83398V26.0088H10.6465V13.7407Z",
    fill: "url(#paint25_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M10.6465 13.7407H7.83398V26.0088H10.6465V13.7407Z",
    fill: "url(#paint26_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M6.89648 13.7407H4.08398V26.0088H6.89648V13.7407Z",
    fill: "url(#paint27_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M6.89648 13.7407H4.08398V26.0088H6.89648V13.7407Z",
    fill: "url(#paint28_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M6.89648 13.7407H4.08398V26.0088H6.89648V13.7407Z",
    fill: "url(#paint29_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M6.89648 13.7407H4.08398V26.0088H6.89648V13.7407Z",
    fill: "url(#paint30_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M27.5215 13.7189V11.2158H3.14648V13.7189H27.5215Z",
    fill: "url(#paint31_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M27.5215 13.7189V11.2158H3.14648V13.7189H27.5215Z",
    fill: "url(#paint32_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M27.5215 13.7189V11.2158H3.14648V13.7189H27.5215Z",
    fill: "url(#paint33_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M27.5215 13.7189V11.2158H3.14648V13.7189H27.5215Z",
    fill: "url(#paint34_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M27.5215 13.7189V11.2158H3.14648V13.7189H27.5215Z",
    fill: "url(#paint35_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M27.5215 13.7189V11.2158H3.14648V13.7189H27.5215Z",
    fill: "url(#paint36_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M2.20898 10.2842C2.20898 9.76855 2.63086 9.34668 3.14648 9.34668H27.5215C28.0371 9.34668 28.459 9.76855 28.459 10.2842C28.459 10.7998 28.0371 11.2217 27.5215 11.2217H3.14648C2.63086 11.2217 2.20898 10.7998 2.20898 10.2842Z",
    fill: "url(#paint37_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M2.20898 10.2842C2.20898 9.76855 2.63086 9.34668 3.14648 9.34668H27.5215C28.0371 9.34668 28.459 9.76855 28.459 10.2842C28.459 10.7998 28.0371 11.2217 27.5215 11.2217H3.14648C2.63086 11.2217 2.20898 10.7998 2.20898 10.2842Z",
    fill: "url(#paint38_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M2.20898 10.2842C2.20898 9.76855 2.63086 9.34668 3.14648 9.34668H27.5215C28.0371 9.34668 28.459 9.76855 28.459 10.2842C28.459 10.7998 28.0371 11.2217 27.5215 11.2217H3.14648C2.63086 11.2217 2.20898 10.7998 2.20898 10.2842Z",
    fill: "url(#paint39_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M2.20898 10.2842C2.20898 9.76855 2.63086 9.34668 3.14648 9.34668H27.5215C28.0371 9.34668 28.459 9.76855 28.459 10.2842C28.459 10.7998 28.0371 11.2217 27.5215 11.2217H3.14648C2.63086 11.2217 2.20898 10.7998 2.20898 10.2842Z",
    fill: "url(#paint40_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M2.20898 10.2842C2.20898 9.76855 2.63086 9.34668 3.14648 9.34668H27.5215C28.0371 9.34668 28.459 9.76855 28.459 10.2842C28.459 10.7998 28.0371 11.2217 27.5215 11.2217H3.14648C2.63086 11.2217 2.20898 10.7998 2.20898 10.2842Z",
    fill: "url(#paint41_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M2.20898 10.2842C2.20898 9.76855 2.63086 9.34668 3.14648 9.34668H27.5215C28.0371 9.34668 28.459 9.76855 28.459 10.2842C28.459 10.7998 28.0371 11.2217 27.5215 11.2217H3.14648C2.63086 11.2217 2.20898 10.7998 2.20898 10.2842Z",
    fill: "url(#paint42_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M2.20898 10.2842C2.20898 9.76855 2.63086 9.34668 3.14648 9.34668H27.5215C28.0371 9.34668 28.459 9.76855 28.459 10.2842C28.459 10.7998 28.0371 11.2217 27.5215 11.2217H3.14648C2.63086 11.2217 2.20898 10.7998 2.20898 10.2842Z",
    fill: "url(#paint43_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_i_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M2.20898 14.0342C2.20898 13.5186 2.63086 13.0967 3.14648 13.0967H27.5215C28.0371 13.0967 28.459 13.5186 28.459 14.0342C28.459 14.5498 28.0371 14.9717 27.5215 14.9717H3.14648C2.63086 14.9717 2.20898 14.5498 2.20898 14.0342Z",
    fill: "url(#paint44_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M2.20898 14.0342C2.20898 13.5186 2.63086 13.0967 3.14648 13.0967H27.5215C28.0371 13.0967 28.459 13.5186 28.459 14.0342C28.459 14.5498 28.0371 14.9717 27.5215 14.9717H3.14648C2.63086 14.9717 2.20898 14.5498 2.20898 14.0342Z",
    fill: "url(#paint45_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M2.20898 14.0342C2.20898 13.5186 2.63086 13.0967 3.14648 13.0967H27.5215C28.0371 13.0967 28.459 13.5186 28.459 14.0342C28.459 14.5498 28.0371 14.9717 27.5215 14.9717H3.14648C2.63086 14.9717 2.20898 14.5498 2.20898 14.0342Z",
    fill: "url(#paint46_linear_434_3160)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M2.20898 14.0342C2.20898 13.5186 2.63086 13.0967 3.14648 13.0967H27.5215C28.0371 13.0967 28.459 13.5186 28.459 14.0342C28.459 14.5498 28.0371 14.9717 27.5215 14.9717H3.14648C2.63086 14.9717 2.20898 14.5498 2.20898 14.0342Z",
    fill: "url(#paint47_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M2.20898 14.0342C2.20898 13.5186 2.63086 13.0967 3.14648 13.0967H27.5215C28.0371 13.0967 28.459 13.5186 28.459 14.0342C28.459 14.5498 28.0371 14.9717 27.5215 14.9717H3.14648C2.63086 14.9717 2.20898 14.5498 2.20898 14.0342Z",
    fill: "url(#paint48_radial_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M28.459 28.0967H2.20898V27.2248C2.20898 26.6717 2.65898 26.2217 3.21211 26.2217H27.4465C27.9996 26.2217 28.4496 26.6717 28.4496 27.2248V28.0967H28.459Z",
    fill: "url(#paint49_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M28.459 28.0967H2.20898V27.2248C2.20898 26.6717 2.65898 26.2217 3.21211 26.2217H27.4465C27.9996 26.2217 28.4496 26.6717 28.4496 27.2248V28.0967H28.459Z",
    fill: "url(#paint50_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M28.459 28.0967H2.20898V27.2248C2.20898 26.6717 2.65898 26.2217 3.21211 26.2217H27.4465C27.9996 26.2217 28.4496 26.6717 28.4496 27.2248V28.0967H28.459Z",
    fill: "url(#paint51_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M28.459 28.0967H2.20898V27.2248C2.20898 26.6717 2.65898 26.2217 3.21211 26.2217H27.4465C27.9996 26.2217 28.4496 26.6717 28.4496 27.2248V28.0967H28.459Z",
    fill: "url(#paint52_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_i_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M18.1465 24.3467H12.5215V18.3748C12.5215 18.0467 12.784 17.7842 13.1121 17.7842H17.5465C17.8746 17.7842 18.1465 18.0561 18.1465 18.3842V24.3467Z",
    fill: "#4B4258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M18.1465 24.3467H12.5215V18.3748C12.5215 18.0467 12.784 17.7842 13.1121 17.7842H17.5465C17.8746 17.7842 18.1465 18.0561 18.1465 18.3842V24.3467Z",
    fill: "url(#paint53_linear_434_3160)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    filter: "url(#filter5_ii_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M15.316 13.0966C16.5617 13.0966 17.7564 12.6018 18.6372 11.7209C19.518 10.8401 20.0129 9.64544 20.0129 8.39976C20.0129 7.15407 19.518 5.9594 18.6372 5.07856C17.7564 4.19773 16.5617 3.70288 15.316 3.70288C14.0703 3.70288 12.8757 4.19773 11.9948 5.07856C11.114 5.9594 10.6191 7.15407 10.6191 8.39976C10.6191 9.64544 11.114 10.8401 11.9948 11.7209C12.8757 12.6018 14.0703 13.0966 15.316 13.0966Z",
    fill: "#B2ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M15.316 13.0966C16.5617 13.0966 17.7564 12.6018 18.6372 11.7209C19.518 10.8401 20.0129 9.64544 20.0129 8.39976C20.0129 7.15407 19.518 5.9594 18.6372 5.07856C17.7564 4.19773 16.5617 3.70288 15.316 3.70288C14.0703 3.70288 12.8757 4.19773 11.9948 5.07856C11.114 5.9594 10.6191 7.15407 10.6191 8.39976C10.6191 9.64544 11.114 10.8401 11.9948 11.7209C12.8757 12.6018 14.0703 13.0966 15.316 13.0966Z",
    fill: "url(#paint54_radial_434_3160)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    filter: "url(#filter6_f_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M16.5336 9.27249C16.5336 9.50687 16.4595 9.71312 16.3189 9.8903C16.1877 10.0591 16.0105 10.1903 15.7949 10.2747C15.7417 10.3015 15.6848 10.3201 15.6261 10.33V10.8728C15.6261 11.0978 15.4105 11.2844 15.1761 11.2844C14.9417 11.2844 14.7195 11.0969 14.7195 10.8719V10.3675C14.5806 10.3488 14.445 10.3109 14.3164 10.255C14.0549 10.1612 13.8402 9.99249 13.6714 9.76843C13.6174 9.69198 13.5909 9.5994 13.5964 9.50593C13.5964 9.35687 13.662 9.23499 13.8027 9.13187C13.9995 9.00999 14.2142 9.03812 14.3914 9.21624C14.4945 9.32874 14.607 9.41312 14.7195 9.46937C14.7289 9.47874 14.7477 9.47874 14.757 9.48812C14.8883 9.54437 15.0467 9.58187 15.2249 9.58187C15.627 9.56312 15.627 9.37562 15.627 9.30062C15.627 9.21624 15.5895 9.15062 15.5052 9.10374C15.402 9.04749 15.2239 8.98187 14.9999 8.92562C14.9052 8.9008 14.8114 8.87298 14.7186 8.84218C14.5874 8.7953 14.4664 8.7578 14.3727 8.71093C14.1945 8.63593 14.0455 8.52343 13.9236 8.36499C13.7924 8.20562 13.7267 7.99937 13.7267 7.7378C13.7267 7.50343 13.7924 7.30749 13.933 7.1303C14.0549 6.96155 14.2236 6.83968 14.4392 6.74593C14.532 6.70843 14.6258 6.67093 14.7195 6.65218V6.09155C14.7195 5.86655 14.9239 5.66968 15.1574 5.66968C15.3917 5.66968 15.6261 5.86655 15.6261 6.09155V6.69062C15.6824 6.69999 15.7292 6.71874 15.7855 6.73749C16.0199 6.83124 16.2167 6.96155 16.348 7.13968C16.423 7.22405 16.4511 7.32718 16.4511 7.42937C16.4511 7.56062 16.4042 7.67312 16.2917 7.75749C16.208 7.82424 16.1028 7.85821 15.9958 7.85303C15.8888 7.84786 15.7874 7.80389 15.7105 7.72937C15.6848 7.70179 15.6565 7.67668 15.6261 7.65437C15.5739 7.60019 15.5101 7.55852 15.4395 7.53249C15.3226 7.47706 15.1938 7.4513 15.0645 7.45749C14.8592 7.45749 14.7664 7.50437 14.7195 7.56062C14.682 7.60749 14.682 7.66374 14.682 7.70124C14.682 7.74812 14.6914 7.79499 14.7195 7.83249C14.7195 7.84187 14.7289 7.85124 14.7383 7.86062C14.7945 7.90655 14.8508 7.94405 14.9352 7.97218C15.0186 8.0003 15.1499 8.0378 15.3177 8.08468C15.4302 8.12218 15.5333 8.1503 15.627 8.17843C15.7395 8.21593 15.8333 8.25343 15.9177 8.29093C16.0855 8.3753 16.2345 8.48687 16.347 8.6453C16.4689 8.80468 16.5345 9.01093 16.5345 9.27343L16.5336 9.27249Z",
    fill: "#6A6177"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    filter: "url(#filter7_i_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M16.6847 9.19653C16.6847 9.43091 16.6097 9.63716 16.4691 9.81528C16.3321 9.98862 16.1507 10.1215 15.9441 10.1997C15.8878 10.2278 15.8316 10.2465 15.7753 10.2559V10.7997C15.7753 11.0247 15.5578 11.2122 15.3235 11.2122C15.0891 11.2122 14.866 11.0247 14.866 10.7997V10.2934C14.727 10.2747 14.5914 10.2368 14.4628 10.1809C14.2003 10.0872 13.9847 9.91841 13.816 9.69341C13.7619 9.61696 13.7354 9.52438 13.741 9.43091C13.741 9.28091 13.8066 9.15903 13.9472 9.05591C14.1441 8.93403 14.3597 8.96216 14.5378 9.14028C14.641 9.25278 14.7535 9.33716 14.866 9.39341C14.8753 9.40278 14.8941 9.40278 14.9035 9.41216C15.0347 9.46841 15.1941 9.50591 15.3722 9.50591C15.7753 9.48716 15.7753 9.29966 15.7753 9.22466C15.7753 9.14028 15.7378 9.07466 15.6535 9.02778C15.5503 8.97153 15.3722 8.90591 15.1472 8.84966C15.0527 8.82412 14.9589 8.79599 14.866 8.76528C14.7347 8.71841 14.6128 8.68091 14.5191 8.63403C14.341 8.55903 14.191 8.44653 14.0691 8.28716C13.9378 8.12778 13.8722 7.92153 13.8722 7.65903C13.8722 7.42466 13.9378 7.22778 14.0785 7.04966C14.2003 6.88091 14.3691 6.75903 14.5847 6.66528C14.6785 6.62778 14.7722 6.59028 14.866 6.57153V6.00903C14.866 5.78403 15.0713 5.58716 15.3056 5.58716C15.54 5.58716 15.7753 5.78403 15.7753 6.00903V6.60903C15.8316 6.61841 15.8785 6.63716 15.9347 6.65591C16.1691 6.74966 16.366 6.88091 16.4972 7.05903C16.5722 7.14341 16.6003 7.24653 16.6003 7.34966C16.6003 7.48091 16.5535 7.59341 16.441 7.67778C16.2722 7.81841 16.0097 7.79966 15.8597 7.64966C15.834 7.62209 15.8057 7.59698 15.7753 7.57466C15.7229 7.52036 15.6587 7.47869 15.5878 7.45278C15.4709 7.39742 15.3421 7.37167 15.2128 7.37778C15.0066 7.37778 14.9128 7.42466 14.866 7.48091C14.8285 7.52778 14.8285 7.58403 14.8285 7.62153C14.8285 7.66841 14.8378 7.71528 14.866 7.75278C14.866 7.76216 14.8753 7.77153 14.8847 7.78091C14.941 7.82778 14.9972 7.86528 15.0816 7.89341C15.166 7.92153 15.2972 7.95903 15.466 8.00591C15.5785 8.04341 15.6816 8.07153 15.7753 8.09966C15.8878 8.13716 15.9816 8.17466 16.066 8.21216C16.2347 8.29653 16.3847 8.40903 16.4972 8.56841C16.6191 8.72778 16.6847 8.93403 16.6847 9.19653Z",
    fill: "#734B9B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    filter: "url(#filter8_f_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M16.1975 7.30753C15.9584 7.0919 15.5234 6.76472 14.8944 6.94753C14.2184 7.1444 14.2419 8.01628 14.8203 8.21503C15.7578 8.53753 16.1975 8.48597 16.2856 9.0569C16.3728 9.62878 15.8234 9.85565 15.2825 9.81159C14.8072 9.77315 14.3619 9.45722 14.2344 9.29128",
    stroke: "#8E66B8",
    strokeWidth: 0.15,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    filter: "url(#filter9_f_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M15.4863 5.91626V6.97001",
    stroke: "#8E66B8",
    strokeWidth: 0.15,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    filter: "url(#filter10_f_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M15.457 9.86865V10.7762",
    stroke: "#8E66B8",
    strokeWidth: 0.15,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    filter: "url(#filter11_f_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M5.6582 14.9717H6.4382V24.8239H5.6582V14.9717Z",
    fill: "url(#paint55_linear_434_3160)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    filter: "url(#filter12_f_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M21.4277 14.9717H22.2077V24.8239H21.4277V14.9717Z",
    fill: "url(#paint56_linear_434_3160)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    filter: "url(#filter13_f_434_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M9.31836 14.9717H10.0984V24.8239H9.31836V14.9717Z",
    fill: "url(#paint57_linear_434_3160)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M27.5223 26.2217H3.11914V25.3498C3.11914 24.7967 3.56914 24.3467 4.12227 24.3467H26.5191C27.0723 24.3467 27.5223 24.7967 27.5223 25.3498V26.2217Z",
    fill: "url(#paint58_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M27.5223 26.2217H3.11914V25.3498C3.11914 24.7967 3.56914 24.3467 4.12227 24.3467H26.5191C27.0723 24.3467 27.5223 24.7967 27.5223 25.3498V26.2217Z",
    fill: "url(#paint59_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M27.5223 26.2217H3.11914V25.3498C3.11914 24.7967 3.56914 24.3467 4.12227 24.3467H26.5191C27.0723 24.3467 27.5223 24.7967 27.5223 25.3498V26.2217Z",
    fill: "url(#paint60_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M27.5223 26.2217H3.11914V25.3498C3.11914 24.7967 3.56914 24.3467 4.12227 24.3467H26.5191C27.0723 24.3467 27.5223 24.7967 27.5223 25.3498V26.2217Z",
    fill: "url(#paint61_linear_434_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M27.5223 26.2217H3.11914V25.3498C3.11914 24.7967 3.56914 24.3467 4.12227 24.3467H26.5191C27.0723 24.3467 27.5223 24.7967 27.5223 25.3498V26.2217Z",
    fill: "url(#paint62_linear_434_3160)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_434_3160",
    x: 3.92383,
    y: 2.4583,
    width: 22.8184,
    height: 8.76338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.352941 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_434_3160",
    x: 4.13672,
    y: 5.14478,
    width: 7.58398,
    height: 5.19946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_434_3160",
    x: 15.2363,
    y: 2.53369,
    width: 10.627,
    height: 7.15308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_434_3160",
    x: 2.20898,
    y: 13.0967,
    width: 26.65,
    height: 1.975,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.4,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.486275 0 0 0 0 0.521569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_434_3160",
    x: 12.1715,
    y: 17.7842,
    width: 5.975,
    height: 6.9125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.35,
    dy: 0.35
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.0784314 0 0 0 0 0.160784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_434_3160",
    x: 10.3191,
    y: 3.40288,
    width: 9.99453,
    height: 9.9938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.3,
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.878431 0 0 0 0 0.937255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3160"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.423529 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3160",
    result: "effect2_innerShadow_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_434_3160",
    x: 13.2957,
    y: 5.36968,
    width: 3.53945,
    height: 6.21475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15,
    result: "effect1_foregroundBlur_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_434_3160",
    x: 13.7402,
    y: 5.33716,
    width: 3.19531,
    height: 5.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.207843 0 0 0 0 0.47451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_434_3160",
    x: 13.8602,
    y: 6.51885,
    width: 2.80898,
    height: 3.673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15,
    result: "effect1_foregroundBlur_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_434_3160",
    x: 15.1121,
    y: 5.54131,
    width: 0.748438,
    height: 1.80361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15,
    result: "effect1_foregroundBlur_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_434_3160",
    x: 15.0828,
    y: 9.4937,
    width: 0.748438,
    height: 1.65737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15,
    result: "effect1_foregroundBlur_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_434_3160",
    x: 4.9082,
    y: 14.2217,
    width: 2.2793,
    height: 11.3523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_434_3160",
    x: 20.6777,
    y: 14.2217,
    width: 2.2793,
    height: 11.3523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_434_3160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_434_3160",
    x: 8.56836,
    y: 14.2217,
    width: 2.2793,
    height: 11.3523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_434_3160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_3160",
    x1: 21.2524,
    y1: 8.61819,
    x2: 9.24023,
    y2: 8.61819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E98A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#847E89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_434_3160",
    x1: 20.9243,
    y1: 7.23632,
    x2: 20.4874,
    y2: 7.93663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#56525D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56525D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_434_3160",
    x1: 9.94336,
    y1: 7.10413,
    x2: 10.2584,
    y2: 7.63194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#56525D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56525D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8109 8.61444) rotate(175.914) scale(2.30253 4.84472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#605D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605D64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_434_3160",
    x1: 17.8877,
    y1: 10.0076,
    x2: 17.8877,
    y2: 9.17038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6870",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_434_3160",
    x1: 6.40258,
    y1: 6.98971,
    x2: 26.991,
    y2: 6.98971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_434_3160",
    x1: 21.6379,
    y1: 6.13846,
    x2: 21.0182,
    y2: 7.13408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD2E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3332 4.20814) rotate(90) scale(1.09864 1.63387)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D797E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E97A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4755 7.7337) rotate(-138.844) scale(2.66625 3.11918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#605C64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605C64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_434_3160",
    x1: 4.88672,
    y1: 9.59415,
    x2: 11.1689,
    y2: 5.53478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2AAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2AAB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_434_3160",
    x1: 15.9863,
    y1: 3.28369,
    x2: 25.3585,
    y2: 9.27432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD3E1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DDD3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#DDD3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDD3E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_434_3160",
    x1: 22.4824,
    y1: 22.3873,
    x2: 18.5571,
    y2: 22.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#56525D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55505C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_434_3160",
    x1: 6.98461,
    y1: 22.3873,
    x2: 11.2127,
    y2: 22.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_434_3160",
    x1: 18.5571,
    y1: 14.5357,
    x2: 18.5571,
    y2: 16.9386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#645A6D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_434_3160",
    x1: 23.7715,
    y1: 19.9571,
    x2: 26.2324,
    y2: 19.9571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB7C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_434_3160",
    x1: 23.4518,
    y1: 19.4124,
    x2: 24.6968,
    y2: 19.4124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_434_3160",
    x1: 26.913,
    y1: 19.0946,
    x2: 25.1777,
    y2: 19.0946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DBEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5387 23.0846) rotate(-90) scale(8.86527 6.03009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_434_3160",
    x1: 20.0215,
    y1: 19.9788,
    x2: 22.4824,
    y2: 19.9788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E99A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_434_3160",
    x1: 19.7018,
    y1: 19.4351,
    x2: 20.9468,
    y2: 19.4351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_434_3160",
    x1: 23.163,
    y1: 19.1173,
    x2: 22.1909,
    y2: 19.1173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7887 23.1063) rotate(-90) scale(8.86527 3.55265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_434_3160",
    x1: 6.73805,
    y1: 19.8729,
    x2: 9.55055,
    y2: 19.8729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_434_3160",
    x1: 7.83398,
    y1: 19.8729,
    x2: 10.2949,
    y2: 19.8729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79747E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_434_3160",
    x1: 7.51336,
    y1: 19.3376,
    x2: 8.7593,
    y2: 19.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_434_3160",
    x1: 10.9755,
    y1: 19.0254,
    x2: 9.63867,
    y2: 19.0254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B1BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.60117 22.947) rotate(-90) scale(8.71404 3.55265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_434_3160",
    x1: 4.08398,
    y1: 19.8729,
    x2: 6.54492,
    y2: 19.8729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E99A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_434_3160",
    x1: 3.76336,
    y1: 19.3376,
    x2: 5.0093,
    y2: 19.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_434_3160",
    x1: 7.22555,
    y1: 19.0254,
    x2: 6.25336,
    y2: 19.0254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.85117 22.947) rotate(-90) scale(8.71404 3.55265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_434_3160",
    x1: 6.2018,
    y1: 12.0755,
    x2: 27.5215,
    y2: 12.0755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A59FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA8B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_434_3160",
    x1: 15.334,
    y1: 11.2158,
    x2: 15.334,
    y2: 11.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676071",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_434_3160",
    x1: 2.94398,
    y1: 12.2339,
    x2: 4.33055,
    y2: 12.2339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7881",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1675 11.216) rotate(128.212) scale(2.51018 5.05898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#645D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#645D6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_434_3160",
    x1: 17.8549,
    y1: 13.7189,
    x2: 17.8549,
    y2: 12.8686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D5A61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_434_3160",
    x1: 27.5215,
    y1: 12.4674,
    x2: 26.7527,
    y2: 12.4674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD2E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_434_3160",
    x1: 15.3321,
    y1: 9.3448,
    x2: 15.3321,
    y2: 11.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09AAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_434_3160",
    x1: 4.96336,
    y1: 11.2217,
    x2: 15.334,
    y2: 11.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A8B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_434_3160",
    x1: 14.2502,
    y1: 11.4598,
    x2: 14.2502,
    y2: 10.2842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7586",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_434_3160",
    x1: 2.20898,
    y1: 10.2842,
    x2: 3.36586,
    y2: 10.2842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7586",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4087 9.5998) rotate(153.223) scale(1.51855 4.06034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#685F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685F73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.104 8.31355) rotate(94.2362) scale(2.48842 13.1436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC3D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3202 9.63449) rotate(-38.2902) scale(1.11248 1.00285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EBFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_434_3160",
    x1: 15.3321,
    y1: 13.0948,
    x2: 15.3321,
    y2: 14.9717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#948B9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_434_3160",
    x1: 1.91086,
    y1: 14.9717,
    x2: 3.19805,
    y2: 14.9717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79747E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79747E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_434_3160",
    x1: 14.2334,
    y1: 15.5323,
    x2: 14.2334,
    y2: 14.3014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787182",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.734 11.9436) rotate(90) scale(1.99219 3.69565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#4E4B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6A72",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3202 13.3845) rotate(-38.2902) scale(1.11248 1.00285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EBFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_434_3160",
    x1: 14.2427,
    y1: 26.2217,
    x2: 14.2427,
    y2: 28.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB8C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_434_3160",
    x1: 15.334,
    y1: 25.8251,
    x2: 15.334,
    y2: 27.4123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#CBC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC3D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_434_3160",
    x1: 2.09273,
    y1: 28.0967,
    x2: 3.41367,
    y2: 28.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79737C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79737C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_434_3160",
    x1: 28.9934,
    y1: 27.1592,
    x2: 27.1643,
    y2: 27.1592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_434_3160",
    x1: 12.5215,
    y1: 22.7154,
    x2: 13.5827,
    y2: 22.7154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4461",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_434_3160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5351 9.20601) rotate(-35.1806) scale(6.70156 6.70157)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#EBE1F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_434_3160",
    x1: 6.0482,
    y1: 23.4317,
    x2: 6.0482,
    y2: 11.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C9D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_434_3160",
    x1: 21.8177,
    y1: 23.4317,
    x2: 21.8177,
    y2: 11.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C9D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_434_3160",
    x1: 9.70836,
    y1: 23.4317,
    x2: 9.70836,
    y2: 11.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#CEC5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC5D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_434_3160",
    x1: 14.3063,
    y1: 24.3467,
    x2: 14.3063,
    y2: 26.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB8C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_434_3160",
    x1: 15.3207,
    y1: 23.9501,
    x2: 15.3207,
    y2: 25.5373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#CBC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC3D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_434_3160",
    x1: 3.01133,
    y1: 26.2217,
    x2: 4.23945,
    y2: 26.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79737C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79737C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_434_3160",
    x1: 28.0191,
    y1: 25.2842,
    x2: 26.3185,
    y2: 25.2842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_434_3160",
    x1: 15.3207,
    y1: 26.6351,
    x2: 15.3207,
    y2: 26.1082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#817B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#817B84",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiBank);
export default __webpack_public_path__ + "static/media/fluent-emoji_bank.72e9e8b9525c70a53f762447dc1b30c6.svg";
export { ForwardRef as ReactComponent };